export default __webpack_public_path__ + "static/media/memory of volcano.a4342531.jpg";